<ol class="w-full flex overflow-hidden">
  @for (menu of menus; track $index; let i = $index) {
    <ng-container *ngTemplateOutlet="menuItem; context: { menu, index: i }" />
  }
</ol>

<ng-template #menuItem let-menu="menu" let-index="index">
  <div
    class="p-4 cursor-pointer no-underline transition-all h-calc hover:border-b-2 hover:border-lPrimary group"
    [ngClass]="
      index === activatedIndex()
        ? 'border-b-2 border-lPrimary'
        : 'border-b-2 border-transparent'
    "
    (click)="toggleMenu(index)"
    (keydown.enter)="toggleMenu(index)"
    tabindex="0"
  >
    @if (menu.submenus?.length) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            menuContent;
            context: { menu, isActive: index === activatedIndex() }
          "
        />
      </div>
    }

    @if (!menu.submenus?.length) {
      <a [routerLink]="'/' + menu.link">
        <ng-container
          *ngTemplateOutlet="
            menuContent;
            context: { menu, isActive: index === activatedIndex() }
          "
        />
      </a>
    }
  </div>
</ng-template>

<ng-template #menuContent let-menu="menu" let-isActive="isActive">
  <div class="flex items-center w-full gap-4">
    <h4 class="text-base group-hover:text-lPrimary transition-colors" [ngClass]="isActive ? 'text-lPrimary' : 'text-[#9E9E9E]'">
      {{ menu.title }}
    </h4>
  </div>
</ng-template>
